import React from "react";
import MicrosoftSignIn from "../../assets/ms-symbollockup_signin_light.svg";

const MicrosoftSignInButton = (props: {
  onClick: () => void;
  disabled?: boolean;
}) => {
  const { onClick, disabled } = props;

  return (
    <button
      type="button"
      aria-label="Sign in with Microsoft"
      onClick={onClick}
      disabled={disabled}
      style={{
        background: "none",
        border: "none",
        cursor: disabled ? "default" : "pointer",
        opacity: disabled ? 0.6 : 1,
        padding: 0,
      }}
    >
      <img src={MicrosoftSignIn} alt="" height={40} />
    </button>
  );
};

export default MicrosoftSignInButton;
